module.exports = __webpack_public_path__ + "static/media/indicator-dark.386d105e.svg";